import { useEffect, useState } from "react";
import "../../App.css";
import { calculateEstimations } from "../domains/domain-utils";

function Request({ state, updateStateField, setExtparField }) {
	const [getRequest, setRequest] = useState(
		{
			zonda: {
				extpar_tag: state.extpar_tag,
			},
			basegrid: {
				keep_basegrid_files: state.keep_basegrid_files,
				grid_root: state.grid_root,
				grid_level: state.grid_level,
				outfile: state.outfile,
				icorotation: state.icorotation,
				icopole_lat: state.icopole_lat,
				icopole_lon: state.icopole_lon,
			},
			domains: state.domains,
		}
	);

	const copyToClipboard = () => {
		navigator.clipboard.writeText(
			JSON.stringify(getRequest, null, 2),
		);
		updateStateField("showModal", true)
	};

	useEffect(() => {
		setRequest({
			zonda: {
				extpar_tag: state.extpar_tag,
			},
			basegrid: {
				keep_basegrid_files: state.keep_basegrid_files,
				grid_root: state.grid_root,
				grid_level: state.grid_level,
				outfile: state.outfile,
				icorotation: state.icorotation,
				icopole_lat: state.icopole_lat,
				icopole_lon: state.icopole_lon,
			},
			domains: state.domains,
		});
	}, [
		state.extpar_tag,
		state.keep_basegrid_files,
		state.grid_root,
		state.grid_level,
		state.outfile,
		state.icorotation,
		state.icopole_lat,
		state.icopole_lon,
		state.domains,
	]);

	useEffect(() => {
		// for requests containing big domains set this to true
		state.domains.forEach((_, index) => {
			const estimation = calculateEstimations(
				state.grid_root,
				state.grid_level + 1,
				index,
				state.domains
			);
			if (estimation.triangles >= 55000000) {
				setExtparField(index, "use_array_cache", true)
			} else {
				setExtparField(index, "use_array_cache", false)
			}

		})
	}, [state.grid_root, state.grid_level, setExtparField, state.domains]);


	return (
		<div className={"content-request"}>
			<h1 className="content-title" id="json-request">Your JSON Request</h1>
			<div className={"request-box"}>
				<div className="valid">Inspect your JSON request and click 'Copy and submit request' below
					to proceed
				</div>
				<pre>{JSON.stringify(getRequest, null, 2)}</pre>
			</div>
			<div
				className={state.showModal ? "copy clicked" : "copy enabled"}
				onClick={copyToClipboard}
			>
				{state.showModal ? "Copied" : "Copy and submit request"}
			</div>
		</div>
	);
}

export default Request;
